














































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class CustomDateField extends Vue {
  @Prop(String) public label;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly clearable!: boolean;

  public date = this.parseDate(this.rec[this.field]);
  public menu1 = false;
  public menu2 = false;

  public formatDate(value) {
    if (value) {
      return moment.utc(value).local().format('DD-MM-YYYY');
    } else {
      return null;
    }
  }

  public parseDate(value) {
    if (value) {
      return moment.utc(value, 'DD-MM-YYYY').local().format('YYYY-MM-DD');
    } else {
      return '';
    }
  }

  public changed() {
    this.menu1 = false;
    this.rec[this.field] = this.formatDate(this.date);
  }

  @Watch('rec') public dateChanged(value: string, oldValue: string) {
    this.date = this.parseDate(this.rec[this.field]);
  }

  public created() {
    const date = this.rec[this.field];
    if (date) {
      // Parse date
      if (date.includes('-')) {
        this.rec[this.field] = date
          .split('-')
          .map((d) => (d = d.length > 1 ? d : '0' + d))
          .join('-');
      } else if (date.includes('/')) {
        this.rec[this.field] = date
          .split('/')
          .map((d) => (d = d.length > 1 ? d : '0' + d))
          .join('-');
      }
    }
  }
}
